import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { Skill } from '../interfaces/store';


type SkillsPdfProps = {
  skills: Skill[];
  color: string; // e.g. 'rgb(59, 130, 246)'
  fontColor: string;
};

const styles = StyleSheet.create({
  skillBlock: {
    marginBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  skillName: {
    fontSize: 12,
    color: 'black'
    // marginBottom: 4,
  },
  circlesContainer: {
    flexDirection: 'row',
    gap: 4,
    marginLeft: '12'
  },
  circle: {
    width: 12,
    height: 12,
    borderRadius: 6,
    marginRight: 6,
    backgroundColor: '#3b83f6', 
  },
});

export const SkillsPdf: React.FC<SkillsPdfProps> = ({ skills, color, fontColor }) => {
  if (fontColor) {
    styles.skillName.color = fontColor
  }
    const content = skills.map((skill, i) => {
  
      return (
        <View key={i} style={[styles.skillBlock, {display: skill.status === 'delete' ? 'none' : 'flex'}]}>
          <Text style={styles.skillName}>{skill.name}</Text>
          <View style={styles.circlesContainer}>
            {[...Array(skill.level)].map((_, j) => (
              <View
                key={j}
                style={{
                  ...styles.circle,
                  backgroundColor: color,
                }}
              />
            ))}
          </View>
        </View>
      );
    });
  
    return <View>{content}</View>;
  };
  
  